import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchMessages } from '../api/messages';

/**
 * Messages (chat + email history) for a lead.
 * Short staleTime — SSE events also invalidate.
 */
export function useMessages (leadId) {
  return useQuery({
    queryKey: queryKeys.messages.byLead(leadId),
    queryFn: () => fetchMessages(leadId),
    enabled: Boolean(leadId),
    staleTime: 30_000, // 30s — SSE invalidates on new messages
  });
}
